import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {

    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const path = '/resourcesources/';
    const paths = {
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllResourceSourcesClassifications: config.endpoints.backend + 'resourcesourcesclassifications/getall',
        endpointSave: config.endpoints.backend + 'resourcesources/save',
        endpointGetById: config.endpoints.backend + 'resourcesources/getById',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Classificação de origem de recursos",
        labelTitleEdit: "Editar Classificação de origem de recursos",
        labelTitleView: 'Visualizar Classificação de origem de recursos'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'pdc_resource_source_classification_id',
                    type: 'select',
                    label: 'Classificação',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllResourceSourcesClassifications,
                        label: 'description',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_entity_id: !!values.pdc_entity_id ? values.pdc_entity_id : profileFilter.pdc_entity_id
                            }
                        },
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Descrição',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
